export default __webpack_public_path__ + "static/media/small.735594be.png";